const intialState = {
  jobs: {} as any,
  loading: false,
  error: null
};

const jobsReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'GET_JOBS_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'GET_JOBS_SUCCESS':
      return {
        ...state,
        loading: false,
        jobs: action.payload.data
      };
    case 'GET_JOBS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload.message
      };
    default:
      return state;
  }
};

export default jobsReducer;
